import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";

import headerImageMobile from "../../../Utils/Assets/Images/headerImageMobile.png";
import winImage from "../../../Utils/Assets/Images/winImage.png";

const MeetUsCoinsSection = () => {
    return (
        <div className={styles.coinsSectionWrapper}>
            <MeetUsWrapper>
                <div className={styles.coinsSectionContent}>
                    <div
                        className={styles.coinsCard}
                        data-aos="fade-left"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <div className={styles.coinsFlex}>
                            <div className={styles.coinsImageContainer}>
                                <div
                                    className={styles.coinsPhoneFrame}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-once="false"
                                >
                                    <img
                                        src={headerImageMobile}
                                        alt="PhasePlaceholder"
                                        className={styles.coinsImage}
                                    />
                                </div>
                                <img
                                    src={winImage}
                                    alt="Feature Host Earning"
                                    className={styles.coinsFloatingImage}
                                    data-aos="fade-left"
                                    data-aos-duration="800"
                                    data-aos-once="false"
                                />
                            </div>

                            <div className={styles.coinsText}  data-aos="fade-left"
                                    data-aos-duration="800"
                                    data-aos-once="false">
                                <h3 className={styles.coinsChip}>Introducing MVR Coins</h3>
                                <h1 className={styles.coinsTitle}>
                                    Your Digital Currency for Real-World Value
                                </h1>
                                <p className={styles.coinsDescription}>
                                    MeetUsVR Coins are the digital currency
                                    powering the MeetUsVR ecosystem. Designed
                                    for seamless transactions within virtual
                                    spaces.
                                </p>
                                <p className={styles.coinsDescription}>
                                    these tokens let you earn rewards, make
                                    purchases, and participate in the growing
                                    metaverse economy. Whether you're gaming,
                                    chatting, or hosting events, MeetUsVR Coins
                                    turn your time into real value.
                                </p>
                                <div className={styles.coinsButtonWrapper}>
                                    <button>Earn Your Coins Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default MeetUsCoinsSection;
